import { Placeholders } from "..";

export const nodePublishLookupEndpoint = "/api/-1/lookupnodeprocessupdates";
export const nodePublishProcessNowEndpoint = `/api/${Placeholders.companyID}/nodeprocessupdates/processnow`;
export const nodePublishProcessLaterEndpoint = `/api/${Placeholders.companyID}/nodeprocessupdates/processlater`;
export const nodePublishCancelUpdatesEndpoint = `/api/${Placeholders.companyID}/nodeprocessupdates/cancelupdates`;
export const nodePublishResendUpdatesEndpoint = `/api/${Placeholders.companyID}/nodeprocessupdates/resendupdates/-1`;
